import BlogListGrid from "../components/BlogListGrid";
import BlogListHeader from "../components/BlogListHeader";
import Head from "next/head";
import Layout from "../components/Layout";
import Metatags from "../components/Metatags";
import PageContent from "../components/PageContent";
import PropTypes from "prop-types";
import { getBlogArticlePages } from "../core/api/blog";
import { getFooter } from "../core/api/core";
import { getMenu } from "../core/api/menu";

export default function BlogListPage({
  menuData,
  globalData,
  data: {
    wagtail: { blogArticlePages },
  },
}) {
  const metaTitle = "The RE_EDIT";
  const metaDescription = "The RE_EDIT";
  return (
    <>
      <Head>
        <title>Reskinned | RE_EDIT</title>
      </Head>
      <Metatags metaTitle={metaTitle} metaDescription={metaDescription} />
      <Layout navItems={menuData} globalData={globalData}>
        <PageContent>
          <BlogListHeader />
          <BlogListGrid pages={blogArticlePages} />
        </PageContent>
      </Layout>
    </>
  );
}

BlogListPage.propTypes = {
  menuData: PropTypes.array.isRequired,
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export async function getStaticProps() {
  const { data } = await getBlogArticlePages();
  const menuData = await getMenu();
  const globalData = await getFooter();

  return {
    props: {
      data,
      menuData,
      globalData,
    },
    revalidate: 300,
  };
}
